import React, { lazy, Suspense, useState } from 'react'
import { CircularProgress } from '@mui/material'
import { FormikProps } from 'formik'
import { IManualDeliveryDetails } from 'types/api/v1/deliveryDetails.type'
interface DeliveryProps {
  formik: FormikProps<IManualDeliveryDetails>
}
const Step1Reschedule = lazy(
  () => import('./ManualRescheduleSteps/Step1RescheduleStep')
)
const Step2Reschedule = lazy(
  () => import('./ManualRescheduleSteps/Step2RescheduleStep')
)
const Step3Reschedule = lazy(
  () => import('./ManualRescheduleSteps/Step3RescheduleStep')
)

function ManualDeliveryRescheduling({ formik }: DeliveryProps) {
  const [activeRescheduleStep, setActiveRescheduleStep] = useState(0)

  const handleNextStep = () => {
    setActiveRescheduleStep((prevNum) => (prevNum += 1))
  }

  return (
    <>
      {activeRescheduleStep === 0 && (
        <Suspense fallback={<CircularProgress />}>
          <Step1Reschedule handleNextStep={handleNextStep} />
        </Suspense>
      )}
      {activeRescheduleStep === 1 && (
        <Suspense fallback={<CircularProgress />}>
          <Step2Reschedule handleNextStep={handleNextStep} formik={formik} />
        </Suspense>
      )}
      {activeRescheduleStep === 2 && (
        <Suspense fallback={<CircularProgress />}>
          <Step3Reschedule />
        </Suspense>
      )}
    </>
  )
}

export default ManualDeliveryRescheduling
